/*
 * Dreamy — barre d'achat collante (S5).
 * Visible quand le bouton principal est sorti de l'écran PAR LE HAUT, masquée dès que l'appel final
 * ou le pied de page est visible, et jamais au-dessus du tiroir panier ni d'une fenêtre (test, menu).
 * Hystérésis de 24 px (motion, D75) : elle n'apparaît que lorsque le bouton est passé 24 px au-dessus du bord
 * de l'écran et ne disparaît que lorsqu'il redevient visible → jamais de clignotement autour du seuil.
 * Mesure au défilement (rAF, passif) : aucun IntersectionObserver propre (un seul observateur partagé : dreamy-motion.js).
 */
if (!customElements.get('dreamy-sticky-atc')) {
  customElements.define(
    'dreamy-sticky-atc',
    class DreamyStickyAtc extends HTMLElement {
      connectedCallback() {
        this.atc = document.querySelector('[data-dreamy-atc]');
        this.text = this.querySelector('[data-sticky-text]');
        this.button = this.querySelector('[data-sticky-submit]');
        this.ends = Array.prototype.slice.call(document.querySelectorAll('[data-dreamy-final], .dr-footer'));
        this.offer = null;
        this.shown = false;
        this.queued = false;
        if (!this.atc) return;

        this.onScroll = () => {
          if (this.queued) return;
          this.queued = true;
          requestAnimationFrame(() => {
            this.queued = false;
            this.render();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        // Tiroir panier (classe .active de Dawn) et fenêtres <dialog> : on se retire.
        var drawer = document.querySelector('cart-drawer');
        var mo = new MutationObserver(this.onScroll);
        if (drawer) mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });

        document.addEventListener('dreamy:offer-change', (e) => {
          this.offer = e.detail.offer;
          if (this.text && e.detail.sticky) this.text.textContent = e.detail.sticky;
        });

        this.button.addEventListener('click', (e) => {
          e.preventDefault();
          var form = this.atc.form || this.atc.closest('form');
          if (!form) return;
          if (window.Dreamy && Dreamy.track) Dreamy.track('dreamy_sticky_atc_click', { offer: this.offer });
          if (typeof form.requestSubmit === 'function') form.requestSubmit(this.atc);
          else this.atc.click();
        });

        this.render();
      }

      disconnectedCallback() {
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
      }

      blocked() {
        var drawer = document.querySelector('cart-drawer');
        return (
          (drawer && drawer.classList.contains('active')) ||
          document.body.classList.contains('dr-dialog-open') ||
          !!document.querySelector('dialog[open]')
        );
      }

      endVisible() {
        var vh = window.innerHeight;
        for (var i = 0; i < this.ends.length; i++) {
          var r = this.ends[i].getBoundingClientRect();
          if (r.top < vh && r.bottom > 0) return true;
        }
        return false;
      }

      render() {
        var bottom = this.atc.getBoundingClientRect().bottom;
        // Hystérésis : apparaît sous −24 px, disparaît au-dessus de 0 px, garde son état entre les deux.
        if (bottom < -24) this.shown = true;
        else if (bottom > 0) this.shown = false;
        var show = this.shown && !this.endVisible() && !this.blocked();
        if (show === this.classList.contains('is-visible')) return;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) this.removeAttribute('inert');
        else this.setAttribute('inert', '');
        document.documentElement.classList.toggle('dr-sticky-on', show);
      }
    }
  );
}
